import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function AccessDeniedPage() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-20 text-center">
      <ShieldX className="h-16 w-16 text-muted-foreground" aria-hidden="true" />
      <h1 className="text-2xl font-semibold">Access Denied</h1>
      <p className="max-w-md text-muted-foreground">
        You don't have permission to view this page. If you believe this is an
        error, contact your administrator.
      </p>
      <Button asChild variant="outline">
        <Link to="/">Back to Dashboard</Link>
      </Button>
    </div>
  );
}
